import { Box, SxProps, Typography } from '@mui/material'
import { ReactNode } from 'react'

interface Props {
    icon?: ReactNode
    title?: string
    description?: string
    sx?: SxProps
}

export const EmptyState = ({ icon, title, description, sx }: Props) => {
    return (
        <Box
            sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                py: '36px',
                px: '16px',
                textAlign: 'center',
                ...sx,
            }}
        >
            {icon && (
                <Box
                    sx={{
                        width: '64px',
                        height: '64px',
                        borderRadius: '50%',
                        backgroundColor: 'rgba(79, 70, 229, 0.08)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mb: '16px',
                        color: 'text.secondary',
                    }}
                >
                    {icon}
                </Box>
            )}
            {title && (
                <Typography
                    fontSize="16px"
                    fontWeight={600}
                    color="text.primary"
                >
                    {title}
                </Typography>
            )}
            {description && (
                <Typography
                    fontSize="13px"
                    color="text.secondary"
                    sx={{ mt: '4px', maxWidth: '360px' }}
                >
                    {description}
                </Typography>
            )}
        </Box>
    )
}

export default EmptyState
